<!-- eslint-disable vue/no-v-html -->
<template>
  <li
    class="selection"
    :class="`selection--${theme}`"
  >
    <div
      v-if="showPriority"
      :id="`priority-${id}`"
      class="selection__counter"
    >
      {{ index }}
    </div>
    <input
      :id="id"
      :aria-describedby="showPriority ? `priority-${id}` : null"
      :disabled="isDisabled"
      :name="group"
      type="checkbox"
      :value="selected"
      @click="update"
      @keyup.enter="update"
    >
    <label
      :for="id"
      class="label"
      :class="`label--${theme}`"
    >
      <picture v-if="hasImage">
        <source
          v-for="source in image.srcset"
          :key="source.media"
          :height="source.height"
          :media="source.media"
          :srcset="source.src"
          :width="source.width"
        >
        <img
          :alt="image.alt"
          class="intrinsic-size"
          :height="image.default.height"
          loading="lazy"
          :src="image.default.src"
          :width="image.default.width"
        >
      </picture>

      <div
        class="label-text"
        v-html="label"
      />

      <div
        v-if="subLabel"
        class="sub-label"
        v-html="subLabel"
      />
    </label>
  </li>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import { selectionTypeSingleSelect } from '../constants';
  export default {
    name: 'Selection',
    props: {
      id: {
        type: String,
        required: true
      },
      image: {
        default: null,
        type: Object,
      },
      index: {
        type: Number,
        required: false,
        default: null
      },
      group: {
        type: String,
        required: true
      },
      label: {
        type: String,
        required: true
      },
      limitReached: {
        type: Boolean,
        required: false
      },
      max: {
        type: Number,
        required: false,
        default: null
      },
      min: {
        type: Number,
        required: false,
        default: 1
      },
      selected: {
        type: Boolean,
        required: true
      },
      showCounter: {
        type: Boolean,
        required: false,
        default: false
      },
      skip: { default: false, type: Boolean },
      subLabel: {
        default: null,
        type: String,
      },
      theme: {
        default: 'text',
        type: String,
      },
      type: {
        type: String,
        required: true
      },
    },
    computed: {
      ...mapGetters('skincareV2Store', [
        'isSkipSelected',
      ]),
      hasImage() {
        return this.image && this.image.default && this.image.default.src;
      },
      inputType() {
        return this.type === selectionTypeSingleSelect ? 'radio' : 'checkbox';
      },
      isDisabled() {
        if (this.skip) {
          return false;
        }

        return this.isSkipSelected || (!this.selected && this.limitReached);
      },
      showPriority() {
        return this.showCounter && this.index;
      }
    },
    methods: {
      ...mapActions('skincareV2Store', [
        'updateSingleSelection',
        'updateMultiSelection'
      ]),
      update() {
        if (this.inputType === 'radio') {
          this.updateSingleSelection({ id: this.id });
        } else {
          this.updateMultiSelection({ id: this.id, skip: this.skip });
        }
      }
    }
  };
</script>
